import * as React from 'react';
import { Box, CssBaseline, Toolbar, Typography, Link } from '@mui/material';
import AppBar from './AppBar';
import Drawer from './Drawer';
import LegalFooterDialog from './LegalFooterDialog';
import FederFooter from './FederFooter';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar onMenuClick={handleDrawerToggle} />
      <Drawer open={mobileOpen} onClose={() => setMobileOpen(false)} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - 240px)` },
          minHeight: '100vh',
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
        }}
      >
        <Toolbar />
        <Box sx={{ minHeight: 'calc(100vh - 128px)' }}>
          {children}
        </Box>
        <Box
          component="footer"
          sx={{
            py: 3,
            width: '100%'
          }}
        >
          <FederFooter />
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 2,
              width: '100%',
              mt: 2,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              <LegalFooterDialog />
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Made with <Box component="span" sx={{ color: 'primary.main' }}>❤️</Box> by{' '}
              <Link href="https://rpidev.com" target="_blank" rel="noopener noreferrer" color="inherit">
                rpidev
              </Link>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
